import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enTranslations from './locales/en.json'
import arTranslations from './locales/ar.json'

/**
 * i18n configuration
 * Supports English (default) and Arabic with RTL
 */
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: localStorage.getItem('language') || 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes values
  },
})

// Set document direction based on language
document.dir = i18n.language === 'ar' ? 'rtl' : 'ltr'

// Listen for language changes and update document direction
i18n.on('languageChanged', (lng) => {
  document.dir = lng === 'ar' ? 'rtl' : 'ltr'
})

export default i18n

